import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Segment, Icon } from "semantic-ui-react";
import "./SessionItem.scss";

export function SessionItem(props) {
  const { session, activeSession } = props;
  const {
    setNodeRef,
    attributes,
    listeners,
    transition,
    transform,
    isDragging,
  } = useSortable({ id: session.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 2 : 1,
  };

  let iconName = "";
  switch (session.type) {
    case "CLASE":
      iconName = "bookmark outline";
      break;
    case "CUESTIONARIO":
      iconName = "question circle outline";
      break;
    case "EXAMEN":
      iconName = "tasks";
      break;
    default:
      iconName = "dont";
  }

  return (
    <div
      className="session-item"
      style={style}
      ref={setNodeRef}
      {...attributes}
      {...listeners}
    >
      <Segment
        className={`${activeSession?.id === session.id ? "active" : ""} ${
          !session.state ? "inactive" : ""
        }`}
      >
        <h4>
          <Icon name={iconName} /> {session.title}
        </h4>
      </Segment>
    </div>
  );
}
